import {
  AddIcon,
  Button,
  CalendarIcon,
  CommunicationIcon,
  Divider,
  DocumentIcon,
  ExpandIcon,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Menu,
  MenuItem,
  OtherResourceIcon,
  ReminderIcon,
  SendIcon,
  UploadIcon,
  ValidateIcon,
  WarningIcon,
} from '@all-manager/design-system-v2';
import AddDocumentsModal from '../../../documents/external-components/AddDocumentsModal/AddDocumentsModal';
import CreateUpdateEventModal from '../../../events/external-components/CreateUpdateEventModal/CreateUpdateEventModal';
import AddUpdateReminder from '../../../reminders/external-components/AddUpdateReminder/AddUpdateReminder';
import AddCallActionModal from '../actionModales/AddCallActionModal/AddCallActionModal';
import AddIncidentActionModal from '../actionModales/AddIncidentActionModal/AddIncidentActionModal';
import AddOtherActionModal from '../actionModales/AddOtherActionModal/AddOtherActionModal';
import AddQuoteApprovedActionModal from '../actionModales/AddQuoteApprovedActionModal/AddQuoteApprovedActionModal';
import AddQuoteReceivedActionModal from '../actionModales/AddQuoteReceivedActionModal/AddQuoteReceivedActionModal';
import AddReminderActionModal from '../actionModales/AddReminderActionModal/AddReminderActionModal';
import { useAddActions } from './useAddActions';

type Props = {
  subjectId: string;
};

export default function AddActions(props: Props) {
  const {
    anchorEl,
    isMenuOpen,
    activeModal,
    handleOpenMenu,
    handleCloseMenu,
    handleSelectAction,
    handleCloseModal,
  } = useAddActions();

  return (
    <>
      <Button
        id="add-actions-button"
        aria-controls={isMenuOpen ? 'add-actions-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={isMenuOpen ? 'true' : undefined}
        variant="contained"
        size="small"
        startIcon={<AddIcon fontSize="small" />}
        endIcon={<ExpandIcon fontSize="small" />}
        onClick={handleOpenMenu}
      >
        Nouvelle action
      </Button>

      <Menu
        id="add-actions-menu"
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleCloseMenu}
        slotProps={{ list: { 'aria-labelledby': 'add-actions-button' } }}
      >
        <ListSubheader>Échanges</ListSubheader>
        <MenuItem onClick={() => handleSelectAction('call')}>
          <ListItemIcon>
            <CommunicationIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Mail ou appel</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleSelectAction('reminderAction')}>
          <ListItemIcon>
            <SendIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Relance</ListItemText>
        </MenuItem>

        <Divider listItem />

        <ListSubheader>Signalements & Planning</ListSubheader>
        <MenuItem onClick={() => handleSelectAction('incident')}>
          <ListItemIcon>
            <WarningIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Incident</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleSelectAction('event')}>
          <ListItemIcon>
            <CalendarIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Rendez-vous</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleSelectAction('reminder')}>
          <ListItemIcon>
            <ReminderIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Rappel</ListItemText>
        </MenuItem>

        <Divider listItem />

        <ListSubheader>Devis & Documents</ListSubheader>
        <MenuItem onClick={() => handleSelectAction('quoteReceived')}>
          <ListItemIcon>
            <DocumentIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Réception de devis</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleSelectAction('quoteApproved')}>
          <ListItemIcon>
            <ValidateIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Bon pour accord</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleSelectAction('documents')}>
          <ListItemIcon>
            <UploadIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Réception de documents</ListItemText>
        </MenuItem>

        <Divider listItem />

        <ListSubheader>Organisation</ListSubheader>
        <MenuItem onClick={() => handleSelectAction('other')}>
          <ListItemIcon>
            <OtherResourceIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Autre action</ListItemText>
        </MenuItem>
      </Menu>

      {activeModal === 'call' ? (
        <AddCallActionModal
          subjectId={props.subjectId}
          onClose={handleCloseModal}
        />
      ) : null}

      {activeModal === 'reminderAction' ? (
        <AddReminderActionModal
          subjectId={props.subjectId}
          onClose={handleCloseModal}
        />
      ) : null}

      {activeModal === 'incident' ? (
        <AddIncidentActionModal
          subjectId={props.subjectId}
          onClose={handleCloseModal}
        />
      ) : null}

      {activeModal === 'event' ? (
        <CreateUpdateEventModal
          subTopicId={props.subjectId}
          onClose={handleCloseModal}
        />
      ) : null}

      {activeModal === 'quoteReceived' ? (
        <AddQuoteReceivedActionModal
          subjectId={props.subjectId}
          onClose={handleCloseModal}
        />
      ) : null}

      {activeModal === 'documents' ? (
        <AddDocumentsModal
          subTopicId={props.subjectId}
          onClose={handleCloseModal}
        />
      ) : null}

      {activeModal === 'quoteApproved' ? (
        <AddQuoteApprovedActionModal
          subjectId={props.subjectId}
          onClose={handleCloseModal}
        />
      ) : null}

      {activeModal === 'other' ? (
        <AddOtherActionModal
          subjectId={props.subjectId}
          onClose={handleCloseModal}
        />
      ) : null}

      {activeModal === 'reminder' ? (
        <AddUpdateReminder
          subjectId={props.subjectId}
          onClose={handleCloseModal}
          displayProviderField
        />
      ) : null}
    </>
  );
}
